import {
  Autocomplete,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import usePatchNote from '../../../hooks/system/usePatchNote';
import usePatchNoteAuthor from '../../../hooks/system/usePatchNoteAuthor';
import usePatchNoteUpdate from '../../../hooks/system/usePatchNoteUpdate';
import { LoadingRow } from '../../dashboard/DashboardOrder/components/GenerateRow';
import { EditPatchNote } from './EditPatchNote.jsx';
import { PatchNoteRow } from './PatchNoteRow.jsx';

const sortOptions = [
  { label: 'Date ↑', field: 'createdAt', value: 1 },
  { label: 'Date ↓', field: 'createdAt', value: -1 },
  { label: 'Release ↑', field: 'releaseNumber', value: 1 },
  { label: 'Release ↓', field: 'releaseNumber', value: -1 },
];

export const PatchNoteTable = ({ displayed }) => {
  const system = useSelector((state) => state?.static?.system);
  const profile = useSelector((state) => state?.login?.profile);
  const { authors, mutateAuthor } = usePatchNoteAuthor({});
  const head = ['Release', 'Responsable', 'Début - Fin', 'Durée'];
  const [edit, setEdit] = useState(false);
  const [selectedPatchNote, setSelectedPatchNote] = useState({});
  const [updateData, setUpdateData] = useState(null);

  const [filterData, setFilterData] = useState({
    checkedAuthor: [],
    sortBy: null,
    sortOrder: null,
  });
  const { patchNotes, isLoading, mutate } = usePatchNote(filterData);
  const updatePatchNote = usePatchNoteUpdate(updateData);

  const onEdit = (value) => {
    setSelectedPatchNote(value);
    setEdit(true);
  };

  const handleUpdate = (value) => {
    setUpdateData({
      id: selectedPatchNote._id,
      author: profile._id,
      releaseNumber: selectedPatchNote.releaseNumber,
      link: value,
    });
    setEdit(false);
  };

  const addAuthor = (authorList) => {
    const idList = authorList?.map((item) => item._id);
    if (idList?.length > 0) {
      setFilterData({
        ...filterData,
        checkedAuthor: idList,
      });
    }
    if (!idList || idList?.length === 0) {
      setFilterData({
        ...filterData,
        checkedAuthor: null,
      });
    }
  };

  useEffect(() => {
    mutate();
    mutateAuthor();
  }, [system, filterData]);

  useEffect(() => {
    updatePatchNote.mutate();
    mutate();
    mutateAuthor();
  }, [updateData]);

  if (!displayed) {
    return null;
  }
  return (
    <>
      <Box
        sx={{
          mt: 4,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          p: 1,
        }}
      >
        <Typography variant="h6" color="primary">
          LISTE DES PATCH NOTES:
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 1,
            width: '50%',
          }}
        >
          <Autocomplete
            disablePortal
            sx={{ minWidth: '25%' }}
            options={sortOptions}
            getOptionLabel={(option) => `${option.label}`}
            onChange={(e, newValue) => {
              setFilterData({
                ...filterData,
                sortBy: newValue ? newValue.field : null,
                sortOrder: newValue ? newValue.value : null,
              });
            }}
            renderInput={(params) => (
              <TextField {...params} label="Trier par" />
            )}
          />
          <Autocomplete
            multiple
            options={authors}
            sx={{ minWidth: '65%' }}
            getOptionLabel={(option) =>
              `${option.firstName} ${option.lastName}`
            }
            onChange={(e, newValue) => addAuthor(newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Responsable" />
            )}
          />
        </Box>
      </Box>
      <Box sx={{ paddingTop: 2 }}>
        <TableContainer
          component={Paper}
          sx={{ borderRadius: 0, padding: '2%' }}
        >
          <Table>
            <TableHead>
              <TableRow>
                {head.map((item, index) => (
                  <TableCell
                    key={index}
                    align="center"
                    sx={{ borderBottom: 1 }}
                  >
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading &&
                Array.from({ length: 10 }).map((_, index) => (
                  <LoadingRow table={head} key={index} />
                ))}
              {!isLoading &&
                patchNotes?.map((data, index) => (
                  <PatchNoteRow
                    key={index}
                    data={data}
                    onEdit={() => onEdit(data)}
                  />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <EditPatchNote
        displayed={edit}
        data={selectedPatchNote}
        onClose={() => setEdit(false)}
        onSave={(value) => handleUpdate(value)}
      />
    </>
  );
};
